module.exports = __webpack_public_path__ + "img/TE-Lockup-RGB-BLUE.579f9bc1.svg";